import { POST } from '@/api'
import visits from './visits'

export default {
  namespaced: true,
  state: {
    busy: false,
    customer: null,
  },
  modules: {
    visits,
  },
  mutations: {
    busy(state, busy) {
      state.busy = !!busy
    },
    set(state, customer = null) {
      state.customer = customer
    },
  },
  actions: {
    async get(store, { id }) {
      const { commit, state } = store
      commit('busy', true)
      commit('set')

      const { status, message, data } = await POST('/api/web/customer/detail', { id })
      if (status === 200) {
        commit('set', data.customer)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200 ? state.customer : null
    },
    async sendPdf(store) {
      const { commit, state } = store
      commit('busy', true)

      const { status, message } = await POST('/api/web/customer/send_pdf', { customerId: state.customer.id })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
